import { required } from 'vuelidate/lib/validators'
import { mapGetters, mapActions } from 'vuex'
import * as components from 'src/components'
import { oneOf } from 'src/utils'
import { Constants } from 'src/constants'

export default {
  components: {
    ...components
  },
  computed: {
    ...mapGetters({
      context: 'passport/context'
    })
  },
  data () {
    return {
      form: {
        password: '',
        confirmPassword: ''
      },
      error: null,
      isErrorVisible: false,
      isBusy: false,
      isPasswordVisible: false,
      isConfirmPasswordVisible: false,
      colorTheme: Constants.colorTheme
    }
  },
  validations: {
    form: {
      password: {
        required,
        isComplex () {
          return this.form.password.length >= 8
        }
      },
      confirmPassword: {
        required,
        same () {
          return this.form.password === this.form.confirmPassword
        }
      }
    }
  },
  methods: {
    ...mapActions({
      signout: 'passport/signout',
      passwd: 'passport/passwd',
      describeError: 'errors/describeError'
    }),
    oneOf,
    reset () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.handleSubmit()
      }
    },
    handleConfirmPassword (value) {
      this.$v.$reset()
      this.form.confirmPassword = value
    },
    handlePassword (value) {
      this.$v.$reset()
      this.form.password = value
    },
    async handleSubmit () {
      this.isBusy = true
      this.isErrorVisible = false
      this.error = null
      // TODO: handle 2fa
      setImmediate(async () => {
        try {
          await this.passwd({
            ...this.form,
            purpose: 'passport'
          })
          setImmediate(() => {
            this.$router.push('/security/signin')
          })
        } catch (e) {
          const { errorMessage } = await this.describeError({ error: e })
          this.error = errorMessage
          this.isErrorVisible = true
        } finally {
          this.isBusy = false
        }
      })
    },
    togglePasswordVisibility () {
      this.isPasswordVisible = !this.isPasswordVisible
    },
    toggleConfirmPasswordVisibility () {
      this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible
    },
    async handleReset () {
      this.signout()
      this.$router.push('/security/signin')
    }
  }
}
